import ReunionsDirect from './ReunionsDirect';

export default ReunionsDirect;
